import './App.css';
import Navigation from './componets/Navigation'
import Footer from './componets/Footer';
import p1 from './imgs/rek1.jpg';
import p2 from './imgs/rek2.jpg';
import p3 from './imgs/edk.jpg';

function App() {
  return (
    <>
      <Navigation />
      <div className='article'>
            <img className="imgs" src={p1} alt='Plakat' />
            <img className="imgs" src={p2} alt='Plakat' />
            <img className="imgs" src={p3} alt='EDK' />
        </div>
      <Footer />
    </>
  );
}

export default App;
